// this is in it's own file because
// it's a server only library (because it imports react-dom/server)

import React from 'react'
import ReactDOMServer from 'react-dom/server'
import {JssProvider, SheetsRegistry} from 'react-jss'

import {
  ILayout,
  ILayout_Render_Context,
} from '../types/layout'

import RenderLayout from './RenderLayout'

const exportHTML = (
  data: ILayout,
  context: ILayout_Render_Context,
): string => {

  const sheets = new SheetsRegistry()

  const RenderElement = (
    <JssProvider registry={sheets}>
      <RenderLayout
        data={ data }
        context={ context }
      />
    </JssProvider>
  )

  const html = ReactDOMServer.renderToStaticMarkup(RenderElement as any)

  return `
    <style type="text/css" id="server-side-styles">
      ${sheets.toString()}
    </style>
    ${html}
  `
}

export default exportHTML